import React, { useEffect, useState } from "react";
import { DatePicker, message, Table, Typography } from "antd";
import dayjs from "dayjs";
import { api } from "../../api/api";
import { IWorkerArchive } from "../../types/archiveWorker.type";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function ArchiveWorker() {
  const [workers, setWorkers] = useState<IWorkerArchive[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchWorkers = async () => {
    setLoading(true);
    try {
      const response = await api.get("/archive/workers", {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });

      const { workers, total } = response.data;

      setWorkers(workers);
      setTotal(total);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение сотрудников.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkers();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата удаления",
      dataIndex: "dateRemoved",
      key: "dateRemoved",
    },
    {
      title: "Удалил",
      dataIndex: "removedBy",
      key: "removedBy",
    },
    {
      title: "Имя",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Фамилия",
      dataIndex: "surname",
      key: "surname",
    },
    {
      title: "Прозвище",
      dataIndex: "nickname",
      key: "nickname",
    },
    {
      title: "Имя пользователя",
      dataIndex: "username",
      key: "username",
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Архив Сотрудников</Title>
      <RangePicker
        onChange={handleRangeChange}
        placeholder={["Начало", "Конец"]}
        format="DD.MM.YY"
        value={dateRange}
      />

      <Table
        columns={columns}
        dataSource={workers}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        loading={loading}
      />
    </div>
  );
}
